// Liefert das Firebase-ID-Token plattformübergreifend.
// Web: aus dem JS-SDK (auth.currentUser). Native: aus dem nativen Auth-Plugin
// (skipNativeAuth:false → der JS-SDK-User ist auf Native leer; das echte Token
// hält die native Firebase-Session). Zentral genutzt von authHeader + exportService.
import { auth } from '../firebase';

const NATIVE = typeof window !== 'undefined' && !!window.Capacitor?.isNativePlatform?.();

export async function getIdTokenSafe(forceRefresh = false) {
  try {
    if (NATIVE) {
      const { FirebaseAuthentication } = await import('@capacitor-firebase/authentication');
      const r = await FirebaseAuthentication.getIdToken(forceRefresh ? { forceRefresh: true } : undefined);
      return r?.token || null;
    }
    const u = auth.currentUser;
    if (!u) return null;
    return await u.getIdToken(forceRefresh);
  } catch {
    return null;
  }
}
